import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthProtecter';

export default function ProtectedRoute({ children, isAuthenticated }) {
  const auth = useAuth();

  console.log(auth.isAuthenticated, 'auth.isAuthenticatedauth.isAuthenticatedauth.isAuthenticatedauth.isAuthenticated')
  return auth.isAuthenticated ? children: <Navigate to={'/signin'} />;
  // return auth.isAuthenticated ? <Outlet /> : <Navigate to={'/signin'} />;
}
